import {
    CLEAR_PROCEDURE_MATERIAL_CALUCATION,
    CLEAR_PROCEDURE_STAFF_CALUCATION,
    EDIT_PROCEDURE_MATERIAL_CALUCATION,
    EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR,
    EDIT_PROCEDURE_STAFF_CALUCATION,
    EDIT_PROCEDURE_STAFF_CALUCATION_ERROR,
    GET_AVAILABLE_MATERIALS,
    GET_AVAILABLE_MATERIALS_ERROR,
    GET_AVAILABLE_STAFF,
    GET_AVAILABLE_STAFF_ERROR,
    GET_DATA,
    GET_DATA_ERROR,
    GET_INDICATORS,
    GET_INDICATORS_ERROR,
    GET_OPKS,
    GET_OPKS_ERROR,
    GET_PROCEDURE,
    GET_PROCEDURE_ERROR,
    GET_PROCEDURE_FOR_PRICING,
    GET_PROCEDURE_FOR_PRICING_ERROR,
    GET_PROCEDURE_MATERIAL_CALUCATION,
    GET_PROCEDURE_MATERIAL_CALUCATION_ERROR,
    GET_PROCEDURE_STAFF_CALUCATION,
    GET_PROCEDURE_STAFF_CALUCATION_ERROR,
    GET_PROCEDURES_SUMMARY,
    GET_PROCEDURES_SUMMARY_ERROR,
    POST_PROCEDURE_MATERIAL_CALUCATION,
    POST_PROCEDURE_MATERIAL_CALUCATION_ERROR,
    POST_PROCEDURE_STAFF_CALUCATION,
    POST_PROCEDURE_STAFF_CALUCATION_ERROR,
    GET_STAFF_ARCHIVE,
    GET_STAFF_ARCHIVE_ERROR,
    GET_MATERIAL_ARCHIVE,
    GET_MATERIAL_ARCHIVE_ERROR,
    DELETE_PROCEDURE_MATERIAL_CALUCATION,
    DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR,
    DELETE_PROCEDURE_STAFF_CALUCATION,
    DELETE_PROCEDURE_STAFF_CALUCATION_ERROR,
    GET_PROCEDURE_ARCHIVE, GET_PROCEDURE_ARCHIVE_ERROR,
    EDIT_ARCHIVE_FAIL,
    EDIT_ARCHIVE_LOADING,
    EDIT_ARCHIVE_MATERIAL,
    EDIT_ARCHIVE_PERSONEL,
} from "./actions";
import {setLoading} from "./IndicatorsActions";
import axios from "axios";
import {EDIT_PROCEDURA_SUCCESS, EDIT_PROCEDURA_FAIL, EDIT_PROCEDURA_SET_LOADING} from "./types"

export const getOpks = () => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_OPKS
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        const data = await res.json();
               if(!res.ok){
                               throw res.error()

        }
        dispatch({
            type: GET_OPKS,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_OPKS_ERROR,
            payload: err,
        });
    }


};

export const getProcedrues = (id, dateAfter) => async (dispatch) => {
    // opk_procedural=1772

    try {
        let url = process.env.REACT_APP_GET_PROCEDURES + "opk_procedural="+ id+"&dateafter=" + dateAfter;
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: GET_PROCEDURE_FOR_PRICING,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_PROCEDURE_FOR_PRICING_ERROR,
            payload: err,
        });
    }


};
//procedure_materialcalc=922???????
//procedurestaff_opk=

export const getProcedureStaff = (id) => async (dispatch) => {
    // opk_procedural=1772

    try {
        let url = process.env.REACT_APP_GET_STAFF_CALCUALTION + "?procedure_staffcalc="+ id;
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
        if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: GET_PROCEDURE_STAFF_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_PROCEDURE_STAFF_CALUCATION_ERROR,
            payload: err,
        });
    }


};

export const getProcedureMaterial = (id) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_MATERIAL_CALCUALTION + "?procedure_materialcalc="+ id;
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
           if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: GET_PROCEDURE_MATERIAL_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_PROCEDURE_MATERIAL_CALUCATION_ERROR,
            payload: err,
        });
    }


};

export const clearProcedureStaff = () => async (dispatch) => {
        dispatch({
            type: CLEAR_PROCEDURE_STAFF_CALUCATION,
        });



};

export const clearProcedureMaterial = () => async (dispatch) => {
        dispatch({
            type: CLEAR_PROCEDURE_MATERIAL_CALUCATION,
        });


};


export const editProcedureMaterial = (item) => async (dispatch) => {
    const id=item.id
    try {
        let url = process.env.REACT_APP_GET_MATERIAL_CALCUALTION + id+"/";
        const res = await fetch(url,{
            method: 'PUT',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            body: JSON.stringify(item)
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: EDIT_PROCEDURE_MATERIAL_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR,
            payload: err,
        });
    }


};
export const deleteProcedureMaterial = (id) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_MATERIAL_CALCUALTION + id+"/";
        const res = await fetch(url,{
            method: 'delete',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );

       if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: DELETE_PROCEDURE_MATERIAL_CALUCATION,
            payload: id,
        });
    } catch (err) {
        dispatch({
            type: DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR,
            payload: err,
        });
    }


};

export const postProcedureMaterial = (item) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_MATERIAL_CALCUALTION;
        const res = await fetch(url,{
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            body: JSON.stringify(item)
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: POST_PROCEDURE_MATERIAL_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: POST_PROCEDURE_MATERIAL_CALUCATION_ERROR,
            payload: err,
        });
    }


};

export const getAvailableStaff = (opk) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_STAFF+'?procedurestaff_opk='+opk
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: GET_AVAILABLE_STAFF,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_AVAILABLE_STAFF_ERROR,
            payload: err,
        });
    }


};
export const getAvailableMaterials= () => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_MATERIAL
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: GET_AVAILABLE_MATERIALS,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_AVAILABLE_MATERIALS_ERROR,
            payload: err,
        });
    }


};


export const editProcedureStaff= (item) => async (dispatch) => {
    const id=item.id
    try {
        let url = process.env.REACT_APP_GET_STAFF_CALCUALTION + id+"/";
        const res = await fetch(url,{
            method: 'PUT',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            body: JSON.stringify(item)
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: EDIT_PROCEDURE_STAFF_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: EDIT_PROCEDURE_STAFF_CALUCATION_ERROR,
            payload: err,
        });
    }


};

export const deleteProcedureStaff= (id) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_STAFF_CALCUALTION + id+"/";
        const res = await fetch(url,{
            method: 'PUT',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );

       if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: DELETE_PROCEDURE_STAFF_CALUCATION,
            payload: id,
        });
    } catch (err) {
        dispatch({
            type: DELETE_PROCEDURE_STAFF_CALUCATION_ERROR,
            payload: err,
        });
    }


};


export const postProcedureStaff = (item) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_STAFF_CALCUALTION;
        const res = await fetch(url,{
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            body: JSON.stringify(item)
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
            throw res.error()
        }
        dispatch({
            type: POST_PROCEDURE_STAFF_CALUCATION,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: POST_PROCEDURE_STAFF_CALUCATION_ERROR,
            payload: err,
        });
    }


};
///edycja procedury
export const editProcedura = (formData, id, flag) => async (dispatch) => {
    dispatch({
        type: EDIT_PROCEDURA_SET_LOADING,
    });

    const config = {
        method: 'put',
        url: `/api/procedure/`+id+'/',
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: EDIT_PROCEDURA_SUCCESS,
        payload: response.data,
        flag:flag
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: EDIT_PROCEDURA_FAIL,
        payload: errors.msg
        });
    }
    }
//

export const getProcedureSummary= (opk_id, show=true, dateAfter) => async (dispatch) => {

    try {
        let url = process.env.REACT_APP_GET_PROCEDURES_SUMMARY+"?opk_procedural="+ opk_id+"&show_procedure="+show +"&dateafter=" + dateAfter;//+"&active=true"+"&calculated=true";
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data=[]
        }
               if(!res.ok){
                        throw res.error()

        }
        dispatch({
            type: GET_PROCEDURES_SUMMARY,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_PROCEDURES_SUMMARY_ERROR,
            payload: err,
        });
    }


};


export const getStaffArchive = (staff_id) => async (dispatch) => {

    try {
        let url = process.env.REACT_APP_GET_STAFF_ARCHIVE+ staff_id+"/archived/";
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data={}
        }
               if(!res.ok){
                        throw res.error()

        }
        dispatch({
            type: GET_STAFF_ARCHIVE,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_STAFF_ARCHIVE_ERROR,
            payload: err,
        });
    }


};

export const getMaterialArchive = (material_id) => async (dispatch) => {

    try {
        let url = process.env.REACT_APP_GET_MATERIAL_ARCHIVE+ material_id+"/archived/";
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data={}
        }
               if(!res.ok){
                        throw res.error()

        }
        dispatch({
            type: GET_MATERIAL_ARCHIVE,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_MATERIAL_ARCHIVE_ERROR,
            payload: err,
        });
    }


};
export const getProcedureArchive = (procedure_id) => async (dispatch) => {
    try {
        let url = process.env.REACT_APP_GET_PROCEDURES_ALL+ procedure_id+"/archived/";
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        let data = await res.json();
        if(data==null) {
            data={}
        }
               if(!res.ok){
                        throw res.error()

        }
        dispatch({
            type: GET_PROCEDURE_ARCHIVE,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_PROCEDURE_ARCHIVE_ERROR,
            payload: err,
        });
    }


};

export const editMaterialArchive = (formData,id) => async (dispatch) => {
    dispatch({ type: EDIT_ARCHIVE_LOADING });

    const config = {
        method: 'put',
        url: `/api/material/`+id+'/',
        data: formData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "JWT " + localStorage.getItem("token")
        },
    };

    try {
        const response = await axios(config);
        dispatch({
            type: EDIT_ARCHIVE_MATERIAL,
            payload: response.data
        });
    } catch (err) {
        dispatch({
            type: EDIT_ARCHIVE_FAIL,
            payload: err
        });
    }
}
export const editPersonelArchive = (formData,id) => async (dispatch) => {
    dispatch({ type: EDIT_ARCHIVE_LOADING });

    const config = {
        method: 'put',
        url: `/api/procedure_staff/`+id+'/',
        data: formData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "JWT " + localStorage.getItem("token")
        },
    };

    try {
        const response = await axios(config);
        dispatch({
            type: EDIT_ARCHIVE_PERSONEL,
            payload: response.data
        });
    } catch (err) {
        dispatch({
            type: EDIT_ARCHIVE_FAIL,
            payload: err
        });
    }
}